module.exports = __webpack_public_path__ + "static/media/name.5e5c0b38.svg";